import {enumAccessControl} from "./gid-access-control";

export enum enumNotificationMedia {
    'E-Mail' = 1,
    'SMS'
}

export namespace enumNotificationMedia {
    export function values() {
        return Object.keys(enumNotificationMedia).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}

export function NotificationMediaToArray(): object[] {
    return Object.keys(enumNotificationMedia)
        .filter(key => typeof enumNotificationMedia[key] === 'number')
        .map(key => ({ id: enumNotificationMedia[key], itemName: key }));
}

export enum enumNotificationType {
    'Notification' = 1,
    'Welcome'
}

export namespace enumNotificationType {
    export function values() {
        return Object.keys(enumNotificationType).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}
export function NotificationTypeToArray(): object[] {
    return Object.keys(enumNotificationType)
        .filter(key => typeof enumNotificationType[key] === 'number')
        .map(key => ({ id: enumNotificationType[key], itemName: key }));
}


export enum enumMessageFormat {
    'Text' = 1,
    'HTML'
}

export namespace enumMessageFormat {
    export function values() {
        return Object.keys(enumMessageFormat).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}

export function MessageFormatToArray(): object[] {
    return Object.keys(enumMessageFormat)
        .filter(key => typeof enumMessageFormat[key] === 'number')
        .map(key => ({ id: enumMessageFormat[key], itemName: key }));
}


export interface NotificationMessage {
    format: enumMessageFormat;
    sender: string;
    subject: string;
    body: string;
}

export interface PortalNotification {
    id: string;
    portalId: number;
    description: string;
    notificationMedia: enumNotificationMedia;
    notificationType: enumNotificationType;
    notificationMessage: NotificationMessage;
    preference: number;
    active: boolean;
}
